import React, { Suspense, useEffect, useState } from "react";
import ExploreOurServices from "./ExploreOurServices/ExploreOurServices";
import "./commonStyle.css";
// import DownloadComponent from "./DownloadComponent/DownloadComponent";
// import WhatsappWidget from "./WhatsappWidget/WhatsappWidget";
import Header from "./Header/Header";
// import MandiBhav from "./MandiBhav/MandiBhav";
import StickyFooter from "./StickyFooter/StickyFooter";
import useIsUserLoggedIn from "./CustomHooks/useIsUserLoggedIn";
// import Registration from "./Registration/Registration";
// import Login from "./Login/Login";
// import Banners from "./Home/Banners/Banners";
import useAllUserData from "./CustomHooks/useAllUserData";
import { isPWA, maxTwoDigitFractionHandler } from "./CommonFunctions/Function";
import { isMobile } from "./helperFunc";
import DesktopHeader from "./DesktopCommonComponents/DesktopHeader/DesktopHeader";
import DesktopFooter from "./DesktopCommonComponents/DesktopFooter/DesktopFooter";
import CreateAccountWidget from "./CreateAccountWidget/CreateAccountWidget";
import DownloadLink from "./DownloadComponent/DownloadLink";
import MandiBhavDesktop from "./MandiBhav/MandiBhavDesktop";
import OptionsComponent from "./OptionsComponent/OptionsComponent";
import { optionsData } from "./Header/constant";
import RightDownloadLink from "./DownloadComponent/RightDownloadLink";
import NeedHelpRight from "./NeedHelp/NeedHelpRight";
import { useSideScrollSticky } from "./CustomHooks/useSideScrollSticky";
import { HomePageServices } from "../../../_services/Arya2.0/HomePageServices";
import NotificationsOnRight from "./Home/NotificationsOnRight/NotificationsOnRight";
import EmailRegisterPopUp from "./Registration/EmailRegisterPopUp";
import useUserDetails from "./CustomHooks/useUserDetails";
import useQueryParams from "./CustomHooks/useQueryParams";
import { LoginServices } from "../../../_services/Arya2.0/Login/LoginServices";
import { customToastr } from "./CustomToastr";
import { useHistory } from "react-router";
import EmailLinkSentPopUp from "./Registration/EmailLinkSentPopUp";
import WarehouseNearMe from "./CommonSuppliesComponent/WarehouseNearMe";
import FlexTitleComponent from "./Trade/Listing/HomepageRevamp4.0/FlexTitle/FlexTitleComponent";
import GetInTouchPopupForm from "./Trade/Listing/HomepageRevamp4.0/GetInTouchPopUp/GetInTouchPopupForm";
import MyActiveLoans from "./Trade/Listing/HomepageRevamp4.0/ActiveLoans/MyActiveLoans";
import MyTradeLimit from "./Trade/Listing/HomepageRevamp4.0/MyTradeLimits/MyTradeLimit";
import AlertsNotification from "./Home/AlertsNotification/AlertsNotification";
import NotificationPreferredLanguage from "./Home/NotificationPreferredLanguage/NotificationPreferredLanguage";
import DownloadAryaAg from "./Home/DownloadAryaAg/DownloadAryaAg";
import FlexComponentMobile from "./Trade/Listing/HomepageRevamp4.0/FlexComponentMobile/FlexComponentMobile";
import MyActiveLoanMobile from "./Trade/Listing/HomepageRevamp4.0/ActiveLoanComponentMobile/MyActiveLoanMobile";
import MyTradeLimitMobile from "./Trade/Listing/HomepageRevamp4.0/MyTradeLimitMobile/MyTradeLimitMobile";
import InvoiceCard from "./Home/InvoiceCard";
import ServiceRequest from "./Home/ServiceRequest";
import MyCommodities from "./Home/MyCommodities";
import CompleteKyc from "./Home/KYCComponent";
import LanguagePreferenceNotification from "./CommonComponents/LanguagePreferenceNotification/LanguagePreferenceNotification";
import { LANG_PREF_CLICKED } from "./GATracker3.0/constants";
import { eventTracker } from "./GATracker3.0/eventTracker";
import FindNow from "./Storage/WareHouse/FindNow";
import moment from "moment";
import { getMonthlyInterestList } from "../../../_services/Arya2.0/Finance/LandingPage/api";
import Loader from "./CommonComponents/Loader/Loader";
import HeadLines from "./CommonComponents/HeadLines";
const DownloadComponent = React.lazy(() =>
  import("./DownloadComponent/DownloadComponent")
);
const WhatsappWidget = React.lazy(() =>
  import("./WhatsappWidget/WhatsappWidget")
);
const Registration = React.lazy(() => import("./Registration/Registration"));
const Login = React.lazy(() => import("./Login/Login"));
const Banners = React.lazy(() => import("./Home/Banners/Banners"));

const MandiBhav = React.lazy(() => import("./MandiBhav/MandiBhav"));
const LoginView = React.lazy(() => import("./Home/HomeScrollView/LoginView"));
const LogoutView = React.lazy(() => import("./Home/HomeScrollView/LogoutView"));
const ExpiredPopup = React.lazy(() => import("./ExpiredPopup"));
const Controller = (props) => {
  const userData = useUserDetails();
  // const [login, setLogin] = useState(false);
  const [userLoggedIn] = useIsUserLoggedIn();
  const allUserData = useAllUserData();
  const [isPwaOpen, setIsPwaOpen] = useState(false);
  const [show, setShow] = useState(false);
  const [regShow, setRegShow] = useState(false);
  const [scrollEvent, setScrollEvent] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [showEmailVerifyPopUp, setShowEmailVerifyPopUp] = useState(false);
  const [showEmailSentPopUp, setShowEmailSentPopUp] = useState(false);
  const [getInTouchSubmitted, setGetInTouchSubmitted] = useState(0);
  const [email, setEmail] = useState("");
  const [isLanguagePreferenceClick, setIsLanguagePreferenceClick] =
    useState(false);
  const [unpaidInterest, setUnpaidInterests] = useState(0);
  const [isLoading, setisLoading] = useState(false);
  const queryParams = useQueryParams() || {};
  const [showShortUrlExpirePopup, setShowShortUrlExpirePopup] = useState(false);
  const history = useHistory();
  const { monthlyInterestActive } = allUserData || {};
  const [areActiveLoansPresent, setAreActiveLoansPresent] = useState(true);

  const getNotificationData = async () => {
    const res = await HomePageServices.getUserNotification();

    // console.log(res);
    if (res?.data?.length) {
      setNotifications(res.data);
    }
  };

  const onScrollEvent = () => {
    setScrollEvent(true);
    window.removeEventListener("scroll", onScrollEvent);
  };
  useEffect(() => {
    document.body?.classList.add("padding-top-unset");
    isPWA(setIsPwaOpen);
    window.addEventListener("scroll", onScrollEvent);
  }, []);
  useEffect(() => {
    userLoggedIn && isMobile && getNotificationData();
  }, [userLoggedIn]);
  const sideScrollFunc = useSideScrollSticky();
  // useEffect(() => {
  //   const data = userData;
  //   if (!data.email && data.email_verified === 0) {
  //     setShowEmailVerifyPopUp(true);
  //   }
  //   if (data?.email && data?.email_verified === 0) {
  //     setShowEmailVerifyPopUp(true);
  //     setEmail(data.email)
  //   }
  // }, [userLoggedIn])
  const handleEmailVerifyPopUp = () => {
    const data = userData;
    setShowEmailVerifyPopUp(true);
    setEmail(data.email);
  };

  const query = window.location.href;
  const match = query.match(/uuid=([^&]*)/);
  let uuid = "";
  if (match) {
    uuid = match[1];
  }

  useEffect(() => {
    if (uuid) {
      verifyEmailToken(uuid);
    }
    if (queryParams["short-url"] === "expired") {
      setShowShortUrlExpirePopup(true);
      history.replace("/");
    }
  }, [queryParams]);
  const verifyEmailToken = async (token) => {
    const response = await LoginServices.emailVerifyToken({ token });
    if (response?.data?.status_code === 200) {
      customToastr({
        text: response?.data?.message,
        type: "success",
        timeOut: 3000,
      });
    }
    history.replace("/");
  };

  const handleLanguagePreference = () => {
    eventTracker("event", LANG_PREF_CLICKED);
    setIsLanguagePreferenceClick(true);
    if (allUserData?.member?.kyc) {
      history.push("/manage-profile/manage-notifications");
    } else {
      setRegShow(true);
    }
  };

  useEffect(() => {
    if (allUserData?.member?.kyc && isLanguagePreferenceClick) {
      handleLanguagePreference();
    } else {
    }
  }, [allUserData?.member?.kyc, isLanguagePreferenceClick]);
  const getMonthlyInterestHistory = async () => {
    setisLoading(true);
    try {
      const response = await getMonthlyInterestList({
        received_date: moment(new Date()).format("YYYY-MM-DD"),
      });
      setUnpaidInterests(response?.data?.total_interest_amount || 0);
      setisLoading(false);
    } catch (error) {
      setisLoading(false);
    }
  };

  useEffect(() => {
    if (userLoggedIn && monthlyInterestActive) getMonthlyInterestHistory();
  }, [userLoggedIn, monthlyInterestActive]);
  return (
    <div className="stdFontStyle font-size16 letterSpacing015  line-height19 ">
      {!isMobile && <DesktopHeader isActive={"Home"} />}

      {/* {show && <Registration show={show} setShow={setShow} />} */}

      {isMobile && (
        <Header
          login={userLoggedIn}
          setShow={setShow}
          isPwaOpen={isPwaOpen}
          notifications={notifications}
        />
      )}
      {show && (
        <Suspense fallback={<></>}>
          <Login
            show={show}
            setShow={setShow}
            setRegShow={setRegShow}
            regShow={regShow}
          />
        </Suspense>
      )}
      {regShow && (
        <Suspense fallback={<></>}>
          <Registration show={regShow} setShow={setRegShow} />
        </Suspense>
      )}
      {showShortUrlExpirePopup && (
        <Suspense fallback={<></>}>
          <ExpiredPopup
            show={showShortUrlExpirePopup}
            setShow={setShowShortUrlExpirePopup}
          />
        </Suspense>
      )}
      {!userLoggedIn ? (
        <>
          <div>
            {!isMobile && <CreateAccountWidget setShow={setShow} />}
            <ExploreOurServices />
            <LanguagePreferenceNotification
              handleClick={handleLanguagePreference}
              setShow={setShow}
              setIsLanguagePreferenceClick={setIsLanguagePreferenceClick}
            />

            {/* <AllowLocation /> */}
            {isPwaOpen ? (
              ""
            ) : isMobile ? (
              <DownloadComponent text="arya.ag App is now available in your Language!" />
            ) : (
              <DownloadLink />
            )}
            {scrollEvent && (
              <Suspense fallback={<></>}>
                <LogoutView />
              </Suspense>
            )}
          </div>
        </>
      ) : (
        <>
          {showEmailVerifyPopUp && (
            <EmailRegisterPopUp
              setShowEmailVerifyPopUp={setShowEmailVerifyPopUp}
              showEmailVerifyPopUp={showEmailVerifyPopUp}
              setEmail={setEmail}
              email={email}
              showVerifyEmailPopUSent={true}
              setShowEmailSentPopUp={setShowEmailSentPopUp}
            />
          )}
          {showEmailSentPopUp && (
            <EmailLinkSentPopUp
              setShowEmailSentPopUp={setShowEmailSentPopUp}
              showEmailSentPopUp={showEmailSentPopUp}
              email={email}
            />
          )}
          {!isMobile && (
            <div className="d-flex justify-content-center">
              <OptionsComponent optionsDataArray={optionsData} />
            </div>
          )}

          <div
            className={
              !isMobile
                ? `width-100 d-flex justify-content-center`
                : "width-100 padding16"
            }
          >
            <div
              className={` ${
                !isMobile && " width-100 padding-left-right30 row m-0 "
              }`}
            >
              <div
                className={`${
                  !isMobile && "col-8 ml-0 mt-0 mb-0 pl-0 pr-0 pt-0 "
                } `}
              >
                {isMobile ? (
                  <>
                    {!userData?.kyc ? (
                      <CompleteKyc />
                    ) : (
                      <>
                        <InvoiceCard />
                        <ServiceRequest />
                      </>
                    )}
                    {!!unpaidInterest && (
                      <FindNow
                        className={`justify-content-space-between align-items-center backAccent3 padding16  d-flex boxRadius8  margin-bottom16 `}
                        buttonParentClassName={
                          isMobile && "flex-center width-50"
                        }
                        buttonClassName={` backgroundWhite padding12 boxRadius6 colorAccent3 font-weight500   mtb-auto
           ${
             isMobile && "line-height16 font-size14 letterSpacing025 "
           } colorDark5 `}
                        title={
                          <HeadLines
                            text={`Your monthly interest due: ₹${maxTwoDigitFractionHandler(
                              unpaidInterest
                            )}`}
                            className={`font-weight500 ${
                              isMobile ? "font-size14 line-height16" : ""
                            } textColorWhite `}
                          />
                        }
                        onClick={() => {
                          history.push("/finance/monthly-interest");
                        }}
                        titleClassName={
                          "font-size14 line-height16 letterSpacing005 font-weight400"
                        }
                        buttonText="View Details"
                      />
                    )}
                    <MyCommodities />
                    {userData?.kyc ? (
                      <>
                        {areActiveLoansPresent && (
                          <MyActiveLoans
                            setAreActiveLoansPresent={setAreActiveLoansPresent}
                          />
                        )}
                        <MyTradeLimitMobile />
                      </>
                    ) : (
                      ""
                    )}
                    <WhatsappWidget />
                    <NotificationPreferredLanguage />
                    <DownloadAryaAg />
                  </>
                ) : (
                  <>
                    {!userData?.kyc ? (
                      <CompleteKyc />
                    ) : (
                      <>
                        <InvoiceCard />
                        <ServiceRequest
                          getInTouchSubmitted={getInTouchSubmitted}
                        />
                      </>
                    )}

                    <MyCommodities />
                    {userData?.kyc ? (
                      <>
                        {areActiveLoansPresent && (
                          <MyActiveLoans
                            setAreActiveLoansPresent={setAreActiveLoansPresent}
                          />
                        )}
                        <MyTradeLimit />
                      </>
                    ) : (
                      ""
                    )}
                  </>
                )}

                {/* <Banners height={isMobile ? 167 : 280} />
                {allUserData?.new_user ? (
                  <ExploreOurServices showScroll={true} />
                ) : (
                  ""
                )}

                {/* {isMobile ? <MandiBhav /> : <MandiBhavDesktop />} */}
                {/* <WhoWeServe /> */}
                {/* <WhatsappWidget /> */}
                {/* <WarehouseNearMe /> */}
                {/* {!isMobile ? (
                  <LanguagePreferenceNotification
                    handleClick={handleLanguagePreference}
                    setIsLanguagePreferenceClick={setIsLanguagePreferenceClick}
                  />
                ) : (
                  ""
                )} */}

                {/*  {scrollEvent && (
                  <Suspense fallback={<></>}>
                    <LoginView />
                  </Suspense>
                )} */}
                {/* <CreateAccountWidget /> */}
                {/* <HeaderDownload /> */}
                {/* <ChnLangPref /> */}
                {/* <OptionsComponent /> */}
              </div>
              {!isMobile && (
                <div
                  className={`${
                    !isMobile &&
                    "maxWidth33 ml-0 mt-0 mr-0 pr-0 pt-0 padding-left30"
                  } `}
                >
                  <div className="position-sticky sticky-sidebar">
                    <div
                      className={`sidebar d-flex flex-d-col ${
                        isMobile ? `gap16` : `gap30`
                      }`}
                    >
                      {!!unpaidInterest && (
                        <FindNow
                          className={`justify-content-space-between align-items-center backAccent3 padding16  d-flex boxRadius8  margin-bottom16 `}
                          buttonParentClassName={
                            isMobile && "flex-center width-50"
                          }
                          buttonClassName={` backgroundWhite padding12 boxRadius6 colorAccent3 font-weight500   mtb-auto
           ${
             isMobile && "line-height16 font-size14 letterSpacing025 "
           } colorDark5 `}
                          title={
                            <HeadLines
                              text={`Your monthly interest due: ₹${maxTwoDigitFractionHandler(
                                unpaidInterest
                              )}`}
                              className={`font-weight500 ${
                                isMobile ? "font-size14 line-height16" : ""
                              } textColorWhite `}
                            />
                          }
                          onClick={() => {
                            history.push("/finance/monthly-interest");
                          }}
                          titleClassName={
                            "font-size14 line-height16 letterSpacing005 font-weight400"
                          }
                          buttonText="View Details"
                        />
                      )}
                      <AlertsNotification />
                      <WhatsappWidget />

                      <NotificationPreferredLanguage />
                      <DownloadAryaAg />
                      {/* <RightDownloadLink />
                      <MyCommodities sideScrollCallback={sideScrollFunc} />
                      <NotificationsOnRight
                        userLoggedIn={userLoggedIn}
                        handleEmailVerifyPopUp={handleEmailVerifyPopUp}
                      />
                      <NeedHelpRight /> */}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </>
      )}
      {isMobile && (
        <StickyFooter
          isActive="Home"
          setGetInTouchSubmitted={setGetInTouchSubmitted}
          getInTouchSubmitted={getInTouchSubmitted}
        />
      )}

      <Loader isLoading={isLoading} />
      {!isMobile && (
        <>
          <DesktopFooter
            setGetInTouchSubmitted={setGetInTouchSubmitted}
            getInTouchSubmitted={getInTouchSubmitted}
          />
        </>
      )}
    </div>
  );
};
export default Controller;
